import { makeStyles } from '@material-ui/core';

const useStepperStyles = makeStyles({
  stepper: {
     transform: 'scale(.5)',
    '& .MuiPaper-root': {
      backgroundColor: 'unset'
    },
    '& .stepper__icon': {
      backgroundColor: 'var(--silver)',
      width: '12px',
      height: '12px',
      borderRadius: '100%',
      zIndex: 1,
      '&.active, &.completed': {
        backgroundColor: 'var(--primary-light)'
      }
    },
    '& .MuiStepConnector-completed > .MuiStepConnector-lineHorizontal, & .MuiStepConnector-active > .MuiStepConnector-lineHorizontal': {
      borderColor: 'var(--primary-light)'

    },
    '& .MuiStepConnector-alternativeLabel': {
      top: '4px',
      left: 'calc(-55% + 10px)',
      right: 'calc(45% + 10px)'
    },
    '& .MuiStepConnector-lineHorizontal': {
      borderTopWidth: '4px',
      borderColor: 'var(--pale-grey-one)'
    }
  }
});

export default useStepperStyles;
